import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { login, logout } from "./redux/slice/loginSlice";
import { updateWechatState } from "./redux/slice/wechatSlice";
import api from "./api";
import { isAndroidOrIOS, isWxOrAli } from "./utils/env";

/**
 * 系统加载时会试图渲染此页面
 * 主要负责判断登陆信息，如果没有登陆，则跳转到登录页
 *
 * @returns 空页面 or 跳转到登陆页
 */
const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const dispatch = useDispatch()
  const loginState = useSelector((state) => state.login)
  const wechatState = useSelector((state) => state.wechat)

  const initWechatState = () => {
    if (wechatState.loaded) {
      return;
    }

    const env = isAndroidOrIOS();
    const newWechatState = {
      url: window.location.href.split("#")[0],
      ios: env === 'ios',
      loaded: true,
      iosReady: false
    }
    dispatch(updateWechatState(newWechatState))
  }

  useEffect(() => {
    // 判断当前是微信 or 支付宝
    const aliOrWx = isWxOrAli();

    // 特殊处理：判断当前平台，为微信jssdk config做准备
    if (aliOrWx === 'wechat') {
      initWechatState();
    }

    // 排除部分特殊route
    if (pathname.indexOf("/login") > -1) {
      return;
    }
    if (pathname === "/") {
      return;
    }

    // 刚打开页面时，请求current用户信息
    if (!loginState.id) {
      api.current().then(res => {
        if (res.data.code === 0) {
          dispatch(login(res.data.data));
        }

        // 未登陆则调整到微信自动登陆页面
        if (res.data.code === 401) {
          dispatch(logout())

          if (aliOrWx === 'alipay') {
            navigate("/login/alipay")
          } else {
            navigate("/login/wechat")
          }
        }
      })
    }
  }, [pathname]);

  return (
    <></>
  )
}

export default App;